import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings')({
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
